import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Header from '../Utility/Components/Header'
import Footer from '../Utility/Components/Footer'
import Left from '../Utility/Components/Left'
import { logOutApp } from '../GlobalModules/Login/Actions/LoginAction';
import NotFoundPage from '../Utility/Pages/NotFound';


const AuthLayout = (props) => {
    const { userCredentials, logOutApp, history, allowedRoles } = props
    const [showNotFound, setShowNotFound] = useState(false);

    useEffect(() => {
        checkForUSerCrendentials()
    }, []);

    const checkForUSerCrendentials = () => {
        if (props.token == undefined || props.token == "") {
            history.push("/")
        }
        if (!props.token || props.token === "" || !allowedRoles.includes(userCredentials.user_details.user_type)) {
            const timer = setTimeout(() => {
                setShowNotFound(true);
            }, 100);
            return () => clearTimeout(timer);
        }
    }
    // Check if current path is CRM pipeline
    const isCRMPipeline = props.history?.location?.pathname?.includes('/crm-pipeline');
    // const isCRMDashboard = props.history?.location?.pathname?.includes('/crm-dashboard');

    return (
        <>
            {/* {props.token && props.token != "" && allowedRoles.includes(userCredentials.user_details.role_name) ? */}
            {props.token && props.token != "" && allowedRoles.includes(userCredentials.user_details.user_type) ?
                <div className="page_customize">
                    <div className="pagecontainer">
                        {!isCRMPipeline && <Header history={props.history} />}
                        {<Left history={props.history} />}
                        <div className={!isCRMPipeline ? (props.leftbar ? 'content_open' : 'content_closed') : 'content_full'} style={{ minHeight: !isCRMPipeline ? '91vh' : '100vh', backgroundColor: !isCRMPipeline ? '#f3f3f9' : 'transparent', paddingTop: '0px', transition: 'padding .3s ease-in-out', display: 'flex', borderRadius: !isCRMPipeline ? '0px 0px 15px 65px' : '0px' }}>{props.children}</div>
                        {userCredentials?.user_details?.version != "v1" && !isCRMPipeline ?
                            <Footer /> : null}
                    </div>
                </div>
                : showNotFound && <><NotFoundPage permission={false} history={props.history} /></>}
        </>
    );

}


const mapStateToProps = (globalState) => {
    //console.log("globalState====auth",globalState);
    return {
        leftbar: globalState.mainReducerData.leftbar,
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
    };

}

export default connect(mapStateToProps, { logOutApp })(AuthLayout);